import {
  RateLimits,
  UnknownQuestions,
} from "@/pages/chatbot/settings/ChatBotSettings.tsx";
import { snakeToCamelObj } from "@/utils/utils.ts";
import { ChatbotBubbleOptions } from "@/components/dialog/ChatbotOpenBubble.tsx";
import { WorkScheduleSettings } from "@/components/WorkSchedule.tsx";
import {IntegrationsSettings} from "@/models/integrations.ts";

export interface Chatbot {
  id: string;
  token: string;
  apikey: string;
  paid: boolean;
  createdAt: Date | null;
  trainedAt: Date | null;
  settings: ChatSettings | null;
  widgetSettings: WidgetOptions;
}

export interface Assistant {
  id: string;
  title: string;
  description: string;
  categories: string[];
  icon: string;
  likes: number;
  isChatbot: boolean; // флаг того что ассистент в чате является созданным чатботом юзера
}

export interface WidgetOptions {
  dialogSettings: ChatBotDialogOptions;
  bubbleSettings: ChatbotBubbleOptions;

  showQuestionsOutside: boolean;
  initialMessages: string;
  initialMessagesAfter: number;
}

export interface ChatSettings {
  name: string;
  systemPrompt: string;
  gptModel: string;
  openAiKey: string;
  maxTokens: number;
  temperature: number;
  contextLength: number;
  domains: string;
  rateLimits: RateLimits;
  leads: Leads;
  schedule: WorkScheduleSettings;
  integrations: IntegrationsSettings
  unknownQuestions: UnknownQuestions;
  conversationLanguage: string;
  translationRules: string;
  slowTyping: number;
  catalog: CatalogSettings;
}

export interface CatalogSettings {
  publish: boolean,
  description: string,
  categories: string[]
}

export interface Leads {
  enableCapture: boolean;
  enableWebhook: boolean;
  enableEmails: boolean;
  instruction: string;
  response: string;
  webhookUrl: string;
  emails: string;
  // TODO deprecate these fields?
  message: string;
  fields: { title: string; description: string }[];
}

export interface ChatBotDialogOptions {
  showOnline: boolean;
  showProfileIconHeader: boolean;
  showProfileIconMessage: boolean;
  voiceToText: boolean;
  hidePoweredBy: boolean;
  footerHtml: string;
  showResponseWebLinks: boolean;
  sourcesAutoExpand: boolean;

  title: string;
  initialMessage: string;
  initialQuestions: string;
  msgUserColor: string;
  msgAssistantColor: string;

  profileIcon: string;
  profileIconBgColor: string | null;
  profileImg: string;

  tabHomeShow: boolean;
  tabHomeShowIcon: boolean;
  tabHomeHtml: string;

  profileFields: FormField[];
}

export interface FormField {
  title: string;
  value?: string;
}

export function mapChatbot(data: any): Chatbot {
  return {
    id: data.id,
    paid: data.paid,
    token: data.token,
    apikey: data.apikey,
    createdAt: data.created_at != 0 ? new Date(data.created_at * 1000) : null,
    trainedAt: data.trained_at != 0 ? new Date(data.created_at * 1000) : null,
    settings: snakeToCamelObj(data.settings) as ChatSettings,
    widgetSettings: snakeToCamelObj(data.widget_settings) as WidgetOptions,
  };
}
